import React, { useEffect } from 'react';
import { useAppSelector } from '../../data/store';
import { sendGaCheckoutEvent } from '../../../../../domain/marketing/gtm-provider';
import { CartSteps } from '../../enums/cart-steps';
import Step3OverviewWithoutLeftSide from '../overview/step-3-overview-without-left-side';

/**
 * Shopping Cart Step #3 without left side
 * https://wavesaudio.atlassian.net/browse/DSWEB-4845
 */
const CartStep3WithoutLeftSide = () => {

    const cartData = useAppSelector(store => store.root.cartData);

    useEffect(() => {
            sendGaCheckoutEvent(CartSteps.Third, cartData);
        },
        // https://wavesaudio.atlassian.net/browse/DSWEB-3345
        // eslint-disable-next-line
        []
    );

    return (
        <div className="flex flex-wrap w-full pb-10">

            <div id="test-log-ph"></div>

            {/*<div className="w-full md:w-7/12 lg:w-3/4 mb-6 md:mb-0">
                <div className="bg-white border rounded md:mr-3 lg:mr-6 px-5 md:px-10">
                    <div className="my-6 max-w-full" style={{
                        width: '430px'
                    }}>
                       Lorem ipsum...
                    </div>
                </div>
            </div>*/}

            <Step3OverviewWithoutLeftSide />

        </div>
    )
};

export default CartStep3WithoutLeftSide;
